import getCurrentSpreadGroup from 'editor/src/store/design/selector/getCurrentSpreadGroup';
import getSpread from 'editor/src/store/design/selector/getSpread';
import getCurrentSpreadContentElements from 'editor/src/store/editor/selector/getCurrentSpreadContentElements';
import getCurrentSpreadIndex from 'editor/src/store/editor/selector/getCurrentSpreadIndex';
import { RootState } from 'editor/src/store/index';

import getBoxesMinMax from 'editor/src/util/getBoxesMinMax';
import filterGroupLayouts from 'editor/src/util/layouts/filterGroupLayouts';

import getAllowedLayouts from './getAllowedLayouts';

// Whether the current spread has any layouts to show. Mirrors the conditions
// SchemasList uses to render items, so callers can avoid presenting an empty
// Layouts tab: there must be an apply area, and either grouped layouts or at
// least one allowed schema for the spread's tags.
const getHasAvailableLayouts = (state: RootState): boolean => {
  const layoutApplyArea = getBoxesMinMax(getCurrentSpreadContentElements(state));
  if (layoutApplyArea.width === 0) {
    return false;
  }

  const spreadGroup = getCurrentSpreadGroup(state);
  if (spreadGroup) {
    return filterGroupLayouts(spreadGroup).length > 0;
  }

  const spread = getSpread(state, getCurrentSpreadIndex(state));
  return (
    getAllowedLayouts(state.editorModules.layouts.schemas, spread?.tags, state.design.autoApplyLayoutSchemaNames)
      .length > 0
  );
};

export default getHasAvailableLayouts;
